import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { GlobalMessageType } from '@spartacus/core'
import { LaunchDialogService, ICON_TYPE } from '@spartacus/storefront'
//import { MyFavoriteDialogService } from './my-favorite-dialog.service';
import { PDPService } from '../services/pdp.services'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../config/dialog.config'
import { CommonService } from '../../../shared/services/common.service'
@Component({
  standalone: false,
  selector: 'app-my-favourite-dialog',
  templateUrl: './my-favourite-dialog.component.html',
  styleUrls: ['./my-favourite-dialog.component.scss'],
})
export class MyFavouriteDialogComponent implements OnInit {
  iconTypes = ICON_TYPE
  @Input()
  favouriteDescription = ''

  currentFavourite
  currentUser
  // @Input() public currentFavorite: any = null;

  createFavouriteCartForm = this.fb.group({
    description: [''],
  })
  dataSource = []
  globalMessageService: any
  pdpService: any

  constructor(
    private fb: FormBuilder,
    private launchDialogService: LaunchDialogService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.commonService.getUserData().subscribe(
      (user) => {
        this.currentUser = user
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  dismissModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.MY_FAVOURITES_PDP,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
  onSubmit() {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.MY_FAVOURITES_PDP,
      reason: 'submit-fav',
      data: {
        myfavdescription: this.favouriteDescription,
      },
    }
    this.launchDialogService.closeDialog(dialogResponse)

    /* this.pdpService
    .updateProductFavouriteComment(this.favouriteDescription)(
      `${PRE_URL}/users/${this.currentUser.uid}/saveProductsToFavourites/`,
      {},
      {
        params: {
          comment: this.favouriteDescription,
        },
      }
    ) */
  }
}
